import _ from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import {
  apiPrefix,
  CasdoorService,
  httpMethodType,
} from "./Casdoor.service";
import { getServerURL } from "../utils/serverUrl";

const premiseURL = getServerURL();

dayjs.extend(utc);
dayjs.extend(timezone);

class UserService extends CasdoorService {
  constructor() {
    super();
    this.basedUrl = `${premiseURL}/${apiPrefix}`;
  }

  async logoutUser(token) {
    const apiName = 'logout';
    const url = `${this.basedUrl}/${apiName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      // body: JSON.stringify(param)
    };
    return super.sendRequest(url, config);
  }

  async getCaptcha(appId, provider) {
    const apiName = 'get-capcha';
    const url = `${this.basedUrl}/${apiName}?applicationId=${appId}&isCurrentProvider=${provider}`;
    const config = {
      method: httpMethodType.get,
      // params: param
    };
    return super.sendRequest(url, config);
  }

  async getUserSetting(orgId, userName) {
    const apiName = 'get-user';
    const url = `${this.basedUrl}/${apiName}?id=${orgId}/${userName}`;
    const config = {
      method: httpMethodType.get,
      // params: param
    };
    return super.sendRequest(url, config);
  }

  async updateUserSetting(orgId, userName, param, token) {
    const apiName = 'update-user';
    const url = `${this.basedUrl}/${apiName}?id=${orgId}/${userName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(param)
    };
    return super.sendRequest(url, config);
  }

  async deleteUserAccount(param, token) {
    const apiName = 'delete-user';
    const url = `${this.basedUrl}/${apiName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(param)
    };
    return super.sendRequest(url, config);
  }

  async checkUserPassword(param, token) {
    const apiName = 'check-user-password';
    const url = `${this.basedUrl}/${apiName}`;
    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(param),
    };
    return super.sendRequest(url, config);
  }

  async updateUserPassword(param, token) {
    const apiName = 'set-password';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async initMfaSetting(param, token) {
    const apiName = 'mfa/setup/initiate';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async verifyMfaSetting(param, token) {
    const apiName = 'mfa/setup/verify';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async enableMfaSetting(param, token) {
    const apiName = 'mfa/setup/enable';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async deleteMfaSetting(param, token) {
    const apiName = 'delete-mfa';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async preferMfaSetting(param, token) {
    const apiName = 'set-preferred-mfa';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

  async sendVerifyMail(param, token) {
    const apiName = 'send-verification-code';
    const url = `${this.basedUrl}/${apiName}`;
    let formatParam = new URLSearchParams(param);

    const config = {
      method: httpMethodType.post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': `Bearer ${token}`
      },
      body: formatParam.toString(),
    };
    return super.sendRequest(url, config);
  }

}

export default new UserService();
